export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-primary-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">联系我们</h2>
          <p className="text-foreground-500 text-sm md:text-base mb-8">
            漫蛙漫画网欢迎漫画作者、版权方和读者与我们联系。
            无论是作品投稿、版权合作、还是问题反馈，我们都会认真对待每一条信息。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70">
              <i className="ri-mail-line text-primary-500 text-lg"></i>
              <span className="text-sm text-foreground-700">contact@manwa.com</span>
            </div>
            <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70">
              <i className="ri-wechat-line text-primary-500 text-lg"></i>
              <span className="text-sm text-foreground-700">漫蛙漫画官方</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}